import { Card, Input } from 'antd';
import { FaStickyNote } from 'react-icons/fa';
const { TextArea } = Input;

const ObservationStep = ({ observacionGeneral, setObservacionGeneral }) => {
  return (
    <Card 
      size="small" 
      style={{ borderLeft: '4px solid #722ed1' }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaStickyNote style={{ color: '#722ed1' }} />
          <span>Observaciones Generales</span>
        </div>
      }
    >
      <TextArea
        rows={6}
        placeholder="Describa en detalle la conversación, información obtenida, compromisos adquiridos, o cualquier observación relevante del contacto..."
        value={observacionGeneral}
        onChange={(e) => setObservacionGeneral(e.target.value)}
        style={{ marginTop: 10 }}
      />
      <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>
        Esta observación será registrada en el historial de la llamada.
      </div>
    </Card>
  );
};

export default ObservationStep;